import { TransmissionSystemOperatorResource } from 'app/_resources/transmission-system-operator.resource';
import { Growl } from 'angular/custom/services/growl.service';
import { ErrorHandler } from 'app/_services/error-handler.factory';
import * as angular from 'angular';

class SecondaryLeadTimeRulesComponentCtrl implements ng.IController {
    authenticatedUser: LoginResult;
    leadTimeRules: LeadTimeRuleDto[];

    newLeadTimeRule?: LeadTimeRuleDto = null;
    idOfLeadTimeBeingDeletedOrEdited?: number = null;

    constructor(
        private TransmissionSystemOperator: TransmissionSystemOperatorResource,
        private growl: Growl,
        private errorHandler: ErrorHandler
    ) {}

    $onInit() {}

    initNewLeadTimeRule() {
        this.newLeadTimeRule = <LeadTimeRuleDto>{
            name: null,
            mode: null,
            contractPeriodType: 'NON_WITHINDAY',
            contractPeriod: null,
            leadTimePeriodForMinimumTimeBefore: {
                value: null,
                type: 'DAY'
            },
            leadTimePeriodForMaximumTimeAhead: {
                value: null,
                type: 'DAY'
            }
        };
    }

    deleteLeadTime(leadTimeId: number): void {
        this.idOfLeadTimeBeingDeletedOrEdited = leadTimeId;

        this.TransmissionSystemOperator.deleteFcfsLeadTimeRule(
            { id: this.authenticatedUser.referenceId, leadTimeId: leadTimeId },
            () => {
                this.growl.show('Successfully deleted.', 'success');
                this.leadTimeRules.splice(
                    this.leadTimeRules.findIndex(
                        (leadTimeRule) => leadTimeRule.id === leadTimeId
                    ),
                    1
                );
            },
            this.errorHandler
        ).$promise.finally(
            () => (this.idOfLeadTimeBeingDeletedOrEdited = null)
        );
    }
}

angular.module('app').component('pkpSecondaryLeadTimeRules', {
    controller: SecondaryLeadTimeRulesComponentCtrl,
    template:
        require('app/operator-settings-secondary-market/secondary-lead-time-rules.component.html'),
    bindings: {
        authenticatedUser: '=',
        leadTimeRules: '='
    }
});
